<template>
  <default-layout>
    <nuxt />
  </default-layout>
</template>

<script>
import DefaultLayout from '~/layouts/default'

export default {
  authenticated: false,

  components: {
    DefaultLayout
  }
}
</script>
